"use client";
import { ReactNode } from "react";
type ModalIconTitleArgs = {
  title:string,
  iconElement:ReactNode
}

export default function ModalIconTitle({ title, iconElement = <></> } : ModalIconTitleArgs) {
  return (
    <table>
      <tbody>
        <tr>
          <td style={{ paddingRight: "10px" }}>{iconElement}</td>
          <td>{title}</td>
        </tr>
      </tbody>
    </table>
  );
}
